import { useLazyQuery } from '@apollo/client';
import React from 'react';
import { FlowColumnFieldLineageLabelsQuery, LabelFragment } from '../../../../../../../gen-src/queries';
import { FeatureFlagsContext } from '../../../featureFlags/FeatureFlagsContext';
import { useContextWithOverride } from '../HookContext';
import { UseLabelsResult, UseLabelsResultWithExecuteFunction } from '../useRenderLabelsTypes';
import { GetContentLineageLabelsLazyQueryParams, convertLabelsFragmentIntoRenderProps } from './lazyQueryHelper';

export function useFlowColumnFieldLineageLabelsLazyQuery({ item, controls, includeParented, includeUpstream, contextOverrides, document }: GetContentLineageLabelsLazyQueryParams): UseLabelsResultWithExecuteFunction {
  const { customSensitivityLabelsEnabled } = useContextWithOverride(FeatureFlagsContext, contextOverrides?.featureFlags);

  const [fire, { loading, error, data }] = useLazyQuery<FlowColumnFieldLineageLabelsQuery>(document);
  const invoke = React.useCallback(() => { void fire({ variables: { id: item.contentId ?? null, customSensitivityLabelsEnabled} }) }, [fire, item, customSensitivityLabelsEnabled]);

  const labelsContainer: LabelFragment[] = [];
  data?.items.forEach(outputField => {
    if (outputField.column?.upstreamColumns) {
      labelsContainer.push(...outputField.column?.upstreamColumns.flatMap(c => c? c.labels: []))
    }
    if (outputField.column?.labels) {
      labelsContainer.push(...outputField.column?.labels)
    }
  });
  const upstreamLabels: LabelFragment[] | undefined = labelsContainer.length > 0 ? labelsContainer : undefined;

  const result: UseLabelsResult = { loading, error, ...convertLabelsFragmentIntoRenderProps({ upstreamLabels, item, controls, includeParented, includeUpstream }) };
  return [invoke, result]
}
